import { useContext } from "react";
import { Link } from "react-router-dom";

import { UserContext } from "../../../../contexts/UserContext";
import moment from "moment";

import { Collapse, Button, Breadcrumb, Menu } from "antd";

import { CaretRightOutlined, HomeOutlined } from "@ant-design/icons";

import { STATUS, urls, USER_ROLES } from "../../../../utils";
import { AtendimentoTabela } from "../../components/AtendimentoTabela";

const { Panel } = Collapse;

const menuBreadcrump = (
  <Menu>
    <Menu.Item>
      <Link to={urls.ATENDIMENTO_GERAL_LIST}>geral</Link>
    </Menu.Item>
  </Menu>
);

export const AtendimentosStatus = () => {
  const { user } = useContext(UserContext);

  return (
    <div id="sectionMain">
      <Breadcrumb id="breadcrumb">
        <Breadcrumb.Item key="home">
          <Link to="">
            <HomeOutlined />
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="registros">registros</Breadcrumb.Item>
        <Breadcrumb.Item key="denuncias">atendimentos</Breadcrumb.Item>
        <Breadcrumb.Item key="denuncias" overlay={menuBreadcrump}>
          <strong>status</strong>
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <div className="container-section">
          <div id="header-container">
            <div>
              <h2>LISTA DE ATENDIMENTOS</h2>
              <span>
                atualizado às {moment().format("HH:mm")} do dia{" "}
                {moment().format("DD/MM/YYYY")}
              </span>
            </div>

            <div id="header-actions">
              {user?.authorities?.includes(USER_ROLES.INCLUIR_DENUNCIA) && (
                <Link to={urls.ATENDIMENTO_CRIAR} className="button-link">
                  <Button type="primary" style={{ width: "160px" }}>
                    novo atendimento
                  </Button>
                </Link>
              )}
            </div>
          </div>

          <Collapse
            className="collapse-personal"
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            expandIconPosition="right"
            ghost
          >
            <Panel
              header={<strong>atendimentos a analisar</strong>}
              key="1"
              className="linear-blue"
            >
              <AtendimentoTabela
                filtro={{ statusDescricao: STATUS.ANALISAR }}
                showTableEmpty={false}
                tipoRegistro="ATENDIMENTO"
              />
            </Panel>

            <Panel
              header={<strong>atendimentos em aberto</strong>}
              key="2"
              className="linear-red"
            >
              <AtendimentoTabela
                filtro={{ statusDescricao: STATUS.ABERTO }}
                showTableEmpty={false}
                tipoRegistro="ATENDIMENTO"
              />
            </Panel>

            <Panel
              header={<strong>atendimentos em andamento</strong>}
              key="3"
              className="linear-yellow"
            >
              <AtendimentoTabela
                filtro={{ statusDescricao: STATUS.ANDAMENTO }}
                showTableEmpty={false}
                tipoRegistro="ATENDIMENTO"
              />
            </Panel>

            <Panel
              header={<strong>atendimentos a validar</strong>}
              key="4"
              className="linear-yellow-dark"
            >
              <AtendimentoTabela
                filtro={{ statusDescricao: STATUS.VALIDAR }}
                showTableEmpty={false}
                tipoRegistro="ATENDIMENTO"
              />
            </Panel>

            <Panel
              header={<strong>atendimentos finalizados</strong>}
              key="5"
              className="linear-green"
            >
              <AtendimentoTabela
                filtro={{ statusDescricao: STATUS.FINALIZADO }}
                showTableEmpty={false}
                tipoRegistro="ATENDIMENTO"
              />
            </Panel>

            {user?.authorities?.includes(USER_ROLES.ARQUIVAR_DENUNCIA) && (
              <Panel
                header={<strong>atendimentos arquivados</strong>}
                key="6"
                className="linear-grey"
              >
                <AtendimentoTabela
                  filtro={{ statusDescricao: STATUS.ARQUIVADA }}
                  showTableEmpty={false}
                  tipoRegistro="ATENDIMENTO"
                />
              </Panel>
            )}
          </Collapse>
        </div>
      </div>
    </div>
  );
};
